import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    Show,
    SimpleShowLayout,
    useTranslate,
    RichTextField,
} from 'react-admin';

export const NotificationList = () => {
    const translate = useTranslate();
    
    return (
        <List>
            <Datagrid rowClick="show">
                <TextField 
                    source="notification_type_display" 
                    label={translate('resources.notifications.fields.notification_type_display')} 
                />
                <DateField 
                    source="reference_date" 
                    label={translate('resources.notifications.fields.reference_date')} 
                />
                <RichTextField 
                    source="content" 
                    label={translate('resources.notifications.fields.content')} 
                />
                <DateField 
                    source="created_at" 
                    label={translate('resources.notifications.fields.created_at')} 
                    showTime 
                />
            </Datagrid>
        </List>
    );
};

export const NotificationShow = () => {
    const translate = useTranslate();
    
    return (
        <Show>
            <SimpleShowLayout>
                <TextField 
                    source="notification_type_display" 
                    label={translate('resources.notifications.fields.notification_type_display')} 
                />
                <TextField 
                    source="notification_type" 
                    label={translate('resources.notifications.fields.notification_type')} 
                />
                <DateField 
                    source="reference_date" 
                    label={translate('resources.notifications.fields.reference_date')} 
                />
                <RichTextField 
                    source="content" 
                    label={translate('resources.notifications.fields.content')} 
                />
                <DateField 
                    source="created_at" 
                    label={translate('resources.notifications.fields.created_at')} 
                    showTime 
                />
                <DateField 
                    source="updated_at" 
                    label={translate('resources.notifications.fields.updated_at')} 
                    showTime 
                />
            </SimpleShowLayout>
        </Show>
    );
}; 